<template>
<b-row>
   <b-col cols="12" xl="12"> 
      <b-card>
        <b-form @submit.prevent="permAdd">
          <b-row>
            <b-col sm="12" md="6">
                <b-form-group label="*Parent:" label-for="permParentField">
                  <b-form-select  :class="{ 'is-invalid' : $v.form.parent_id.$error }"  v-model="$v.form.parent_id.$model" :options="permParentItems"  id="permParentField"  aria-describedby="permShowMField" />    
                    <b-form-invalid-feedback id="permParentField">
                       This is a required field
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>           
            <b-col sm="12" md="6">
                <b-form-group label="*Sort Order:" label-for="permOrder">
                    <b-form-input maxlength="40" :class="{ 'is-invalid' : $v.form.sort_order.$error }" id="inputpermOrder" v-model="$v.form.sort_order.$model" type="text" class="form-control" placeholder="Enter Sort Order"   aria-describedby="inputpermOrder" />
                    <b-form-invalid-feedback id="inputpermOrder" v-if="!$v.form.sort_order.required">
                       This is a required field
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback id="inputpermOrder" v-if="!$v.form.sort_order.numeric">
                      Numeric value only
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
                <b-form-group label="*Label:" label-for="permissionname">
                    <b-form-input maxlength="200" :class="{ 'is-invalid' : $v.form.label.$error }" id="permNameField" v-model="$v.form.label.$model" type="text" class="form-control" placeholder="Enter Permission Name"  aria-describedby="permNameField" />
                    <b-form-invalid-feedback id="permNameField">
                      This is a required field
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
            <b-col sm="12" md="6">
                <b-form-group label="URL:" label-for="permUrl">
                    <b-form-input maxlength="40" id="inputpermurl" v-model="form.route_url" type="text" class="form-control" placeholder="Enter URL"   aria-describedby="inputpermurl" />
                </b-form-group>    
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
                <b-form-group label="Sidebar Icon Class:" label-for="permIcon">
                    <b-form-input maxlength="40" id="permIconField" v-model="form.menu_icon" type="text" class="form-control" placeholder="Sidebar Icon Class"  aria-describedby="orgbillingstateField" />
                </b-form-group>    
            </b-col>
            <b-col sm="12" md="6">
                <b-form-group label="*Show In Side Bar Menu:" label-for="permShowMField">
                  <b-form-select  :class="{ 'is-invalid' : $v.form.menu_show.$error }"  v-model="$v.form.menu_show.$model" :options="permMenuSItems"  id="permShowMField"  aria-describedby="permShowMField" />    
                  <b-form-invalid-feedback id="permShowMField">
                       This is a required field
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
                <b-form-group label="*Status:" label-for="permStatusField">
                  <b-form-select  :class="{ 'is-invalid' : $v.form.status.$error }"  v-model="$v.form.status.$model" :options="permStatusItems"  id="permStatusField"  aria-describedby="permShowMField" />    
                  <b-form-invalid-feedback id="permStatusField">
                       This is a required field
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="12">
                <b-form-group label="*Short Description:" label-for="permDescField">
                  <b-form-textarea
                    id="permDescField"
                    :class="{ 'is-invalid' : $v.form.description.$error }"
                    v-model="$v.form.description.$model"
                    placeholder="Enter something..."
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>    
                  <b-form-invalid-feedback id="permStatusField">
                       This is a required field
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
          </b-row>
        
          <b-row style="margin-top:20px;">
            <b-col cols="12">
              <b-button type="button" v-b-tooltip.hover title="Cancel" variant="secondary" @click.stop="gotolist()"  class="px-4">Cancel</b-button>
              <b-button type="submit" v-b-tooltip.hover title="Save" variant="primary"  class="px-4 pull-right">Save</b-button> 
            </b-col>
          </b-row>
        </b-form>
      </b-card>
  </b-col>
</b-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'  
import { validationMixin } from 'vuelidate' 
import { required, maxLength, numeric } from 'vuelidate/lib/validators'
import { getResponseMessages } from '../../_helpers'
export default {
  name: 'Permission_Add',
  data() {
    return {
      permParentItems: [{
        text: 'Please select',
        value: '',
      },{
        text: 'Create as Parent',
        value: 0,
      }],
      permMenuSItems: [{
        text: 'Please select',
        value: '',
      },{
        text: 'Yes',
        value: 1,
      },{
        text: 'No',
        value: 0,
      }],
      permStatusItems: [{
        text: 'Please select',
        value: '',
      },{
        text: 'Active',
        value: 0,
      },{
        text: 'Inactive',
        value: 1,
      }],
      form: {
        parent_id:'',
        sort_order:'',
        label:'',
        route_url:'',
        menu_icon:'',
        menu_show:'',
        status:'',
        description:''
      }
    }
  },
  mixins: [
    validationMixin
  ],
  validations: {
    form: {
      label: {
        required,
        maxLength: maxLength(200)
      },
      description: {
        required,
        maxLength: maxLength(400)
      },
      menu_show: {
        required
      },
      sort_order: {
        required,
        numeric
      },
      status: {
        required
      },
      parent_id: {
        required
      }
    }  
  },
  created(){
    if(this.$route.params.id != undefined){
      this.loadPermissionData(this.$route.params.id);
      this.getPermById(this.$route.params.id)
    }else{
      this.loadPermissionData(0);
    }
  },  
  methods: {
     ...mapActions('org', ['getById','uploadData']),
    permAdd() {
      this.$v.form.$touch();
      if(this.$v.form.$error) return
      this.$store.dispatch('saveData',{url:'Permission/savePermission',data: this.form }).then((res) => {
        this.$toastr('success', getResponseMessages(res.data.messages), 'Success')
        this.$router.push('/permission')
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    },
    gotolist () {
        this.$router.push('/permission/list')
    },
    loadPermissionData(id) {
      this.$store.dispatch('getById', {url:'Permission/getParentMenuList',data :{permission_id:id}}).then((res) => {
        if(Array.isArray(res.results)){
          res.results.forEach((version) => {
            var parentItemsD = {
              text: version.label,
              value: version.id
            }
            this.permParentItems.push(parentItemsD);
          });
        }
      },(error) =>{
        console.log(error)
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    },
    getPermById(id) {
      this.$store.dispatch('getById', {url:'permission/getPermById',data : { 'permission_id':id }}).then((res) => {
        this.form = Object.assign({}, res)  
        // this.previewSImage = res.orglogoimage;
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    }
  },
}
</script>
<style type="text/css">
  .vc-chrome {
  position: absolute;
  top: 35px;
  right: 0;
  z-index: 9;
}
.current-color {
  width: 40px;
  height: 35px;
  cursor: pointer;
}
</style>